/* Katsusaki Zen Luxury - beteenden. Ren JS, inga beroenden. */
(function () {
  'use strict';
  var d = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  /* direkt till kassan (Elliot 2026-11-03): töm korgen, lägg bara den valda varan, gå till /checkout */
  /* Motion UI: knapp som sjunker och fjädrar tillbaka, samt cirkel-sen-bock (470 ms) när varan registrerats */
  (function () {
    var st = d.createElement('style');
    st.textContent = '.kz-btn{transition:background .2s,color .2s,border-color .2s,transform .55s cubic-bezier(.34,1.56,.64,1)}' +
      '.kz-btn:active:not(:disabled),.kz-btn.kz-sunk{transform:scale(.95);transition-duration:.2s,.2s,.2s,.09s;transition-timing-function:ease-out}' +
      '.kz-btn.kz-sunk{transform:scale(.97)}' +
      '.kz-tick{width:24px;height:24px;display:block;margin:0 auto;overflow:visible}' +
      '.kz-tick circle,.kz-tick path{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}';
    d.head.appendChild(st);
  })();
  function kzTick(btn) {
    var el = btn.querySelector('[data-kz-btn-label]') || btn;
    btn.classList.add('kz-sunk');
    el.innerHTML = "<svg class='kz-tick' viewBox='0 0 24 24' aria-hidden='true'><circle cx='12' cy='12' r='10' stroke-dasharray='63' stroke-dashoffset='63'/><path d='M7 12.5l3.2 3.2L17 9' stroke-dasharray='14' stroke-dashoffset='14'/></svg>";
    el.setAttribute('aria-label', 'Tillagd');
    var c = el.querySelector('circle'), p = el.querySelector('path');
    if (reduce || !c.animate) { c.style.strokeDashoffset = 0; p.style.strokeDashoffset = 0; return 120; }
    c.animate([{ strokeDashoffset: 63 }, { strokeDashoffset: 0 }], { duration: 280, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'forwards' });
    p.animate([{ strokeDashoffset: 14 }, { strokeDashoffset: 0 }], { duration: 190, delay: 280, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'forwards' });
    return 650;
  }
  window.kzTick = kzTick;
  function kzToCheckout(id, qty, btn) {
    var h = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    return fetch('/cart/clear.js', { method: 'POST', headers: h, credentials: 'same-origin' })
      .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: h, credentials: 'same-origin', body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] }) }); })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j && (j.description || j.message) || 'error'); }); })
      .then(function () {
        var wait = btn ? kzTick(btn) : 0;
        setTimeout(function () { window.location.href = '/checkout'; }, wait);
      });
  }
  window.kzToCheckout = kzToCheckout;

  /* header: topphöjd, mobilmeny, dölj länkar utan mål, rotera notisrad på mobil */
  function initHeader() {
    var top = $('[data-kz-top]');
    if (top) {
      var set = function () { d.documentElement.style.setProperty('--kz-top-h', top.offsetHeight + 'px'); };
      set(); window.addEventListener('resize', set);
    }
    $$('[data-kz-nav] a, [data-kz-mnav] a').forEach(function (a) {
      var h = a.getAttribute('href');
      if (h && h.charAt(0) === '#' && h.length > 1 && !d.querySelector(h)) a.style.display = 'none';
    });
    var btn = $('[data-kz-menu]'), mn = $('[data-kz-mnav]');
    if (btn && mn) {
      btn.addEventListener('click', function () {
        var open = mn.hasAttribute('hidden');
        if (open) mn.removeAttribute('hidden'); else mn.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      mn.addEventListener('click', function (e) { if (e.target.tagName === 'A') { mn.setAttribute('hidden', ''); btn.setAttribute('aria-expanded', 'false'); } });
    }
    var list = $('[data-kz-rotate]');
    if (list && !reduce) {
      var items = $$('.kz-bar__item', list), i = 0;
      if (items.length > 1) {
        list.classList.add('is-rot'); items[0].classList.add('is-active');
        setInterval(function () { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, 3500);
      }
    }
  }

  /* reveal */
  function initReveal() {
    /* inga scroll-animationer längre (2026-11-03): allt syns direkt */
    $$('.kz-reveal').forEach(function (e) { e.classList.add('is-in'); });
  }

  /* galleri: mjuk crossfade mellan bilder och videoloopar, ingen zoom */
  function initGallery() {
    var g = $('[data-kz-gallery]'); if (!g) return;
    var track = $('[data-kz-track]', g), slides = $$('[data-kz-slide]', g), thumbs = $$('[data-kz-thumb]', g), count = $('[data-kz-count]', g), dots = $$('[data-kz-dot]', g);
    var idx = -1, fadeT;
    function play(s, on) {
      var v = s.querySelector('video'); if (!v) return;
      if (on) load(v);
      if (on && !reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
    }
    function mark(i) {
      if (i === idx) return;
      var prev = idx; idx = i;
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      /* aktiv miniatyr rullas in i raden (bara raden, aldrig sidan) */
      var row = thumbs[i] && thumbs[i].closest('ul');
      if (row && row.scrollWidth > row.clientWidth) { var li = thumbs[i].parentNode; row.scrollTo({ left: Math.max(0, li.offsetLeft - row.offsetLeft - 8), behavior: reduce ? 'auto' : 'smooth' }); }
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      dots.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      /* föregående bild ligger kvar fullt synlig under tills den nya tonat in: ingen mörk blink */
      slides.forEach(function (s, k) { s.classList.toggle('is-prev', k === prev); });
      clearTimeout(fadeT); fadeT = setTimeout(function () { slides.forEach(function (s) { s.classList.remove('is-prev'); }); }, 360);
      if (slides[prev]) play(slides[prev], false);
      play(slides[i], true);
      /* förladda bara nästa loop (metadata), aldrig alla på en gång */
      var nx = slides[(i + 1) % slides.length], nv = nx && nx.querySelector('video'); if (nv) load(nv);
    }
    function go(i) { var n = slides.length; if (!n) return; mark((i + n) % n); }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    $$('[data-kz-prev]', g).forEach(function (b) { b.addEventListener('click', function () { go(idx - 1); }); });
    $$('[data-kz-next]', g).forEach(function (b) { b.addEventListener('click', function () { go(idx + 1); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(idx + 1); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { go(idx - 1); e.preventDefault(); }
    });
    /* svep: horisontell rörelse över 40 px byter bild, vertikal scroll lämnas i fred */
    var sx = null, sy = 0;
    track.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (sx === null) return; var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy; sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) go(idx + (dx < 0 ? 1 : -1));
    }, { passive: true });
    /* dra med mus på dator */
    var mx = null;
    track.addEventListener('mousedown', function (e) { mx = e.clientX; });
    window.addEventListener('mouseup', function (e) { if (mx === null) return; var dx = e.clientX - mx; mx = null; if (Math.abs(dx) > 50) go(idx + (dx < 0 ? 1 : -1)); });
    /* looparna laddas först när de (eller bilden före) visas, sparar mobildata; pausas när galleriet inte syns */
    function load(v) { var src = v.getAttribute('data-src'); if (src && !v.getAttribute('src')) { v.preload = 'metadata'; v.src = src; } }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { if (slides[idx]) play(slides[idx], en[0].isIntersecting); }).observe(track);
    }
    mark(0);
  }

  /* paketväljare + köp */
  function initBuy() {
    var form = $('[data-kz-form]'); if (!form) return;
    var radios = $$('input[name="kz-bundle"]', form), idInput = $('[data-kz-variant-id]', form);
    var btn = $('[data-kz-add]', form), msg = $('[data-kz-msg]', form);
    var shipEl = $('[data-kz-ship]', form), qtyEls = $$('[data-kz-qty]', form), noteEl = $('[data-kz-note]', form);
    /* erbjudandetest: ?offer=A/B/C/D (sparas i sessionStorage), annars temainställningen */
    var offers = $('[data-kz-offers]', form);
    if (offers) {
      var want = null;
      try { want = new URL(location.href).searchParams.get('offer'); } catch (e) {}
      if (want) { want = want.toUpperCase(); try { sessionStorage.setItem('kz-offer', want); } catch (e) {} }
      else { try { want = sessionStorage.getItem('kz-offer'); } catch (e) {} }
      var grp = want && $('[data-kz-offer="' + want + '"]', offers);
      if (grp && want !== offers.getAttribute('data-default')) {
        $$('[data-kz-offer]', offers).forEach(function (g) {
          var on = g === grp; g.hidden = !on;
          $$('input[name="kz-bundle"]', g).forEach(function (r) { r.disabled = !on; if (!on) r.checked = false; });
        });
        var def = $('input[data-default]', grp) || $('input[name="kz-bundle"]', grp);
        if (def) def.checked = true;
        var hd = $('[data-kz-offerhead]', form); if (hd) hd.textContent = grp.getAttribute('data-head');
        var cta = $('[data-kz-cta]'), pct = grp.getAttribute('data-pct');
        if (cta && pct && pct !== '0') cta.textContent = cta.getAttribute('data-tpl').replace('{pct}', pct);
      }
      radios = radios.filter(function (r) { return !r.disabled; });
    }
    function sel() { return radios.filter(function (r) { return r.checked; })[0] || radios[0]; }
    /* rullande siffror i köpknappen: "TILL KASSAN · 1 039 kr" */
    var rollReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    (function () {
      var st = d.createElement('style');
      st.textContent = '[data-kz-btn-label]{display:inline-flex;align-items:center;justify-content:center;gap:.45em;line-height:1.25;font-weight:800}' +
        '.kz-add-btn{font-size:17px;font-weight:800;letter-spacing:.12em}.kz-add-btn .kz-roll{font-size:1.18em}' +
        '.kz-pre{display:inline-block;line-height:1.25em;white-space:pre}' +
        '.kz-roll{display:inline-flex;align-items:center;white-space:pre;font-variant-numeric:tabular-nums;height:1.25em}' +
        '.kz-roll>span{display:inline-block;height:1.25em;line-height:1.25em}' +
        '.kz-rc{display:inline-block;height:1.25em;line-height:1.25em;overflow:hidden}' +
        '.kz-rs{display:block;will-change:transform;transform:translateY(0)}' +
        '.kz-rs i{display:block;font-style:normal;height:1.25em;line-height:1.25em}';
      d.head.appendChild(st);
    })();
    function setBtnLabel(label, prefix, price, animate) {
      var full = prefix + ' · ' + price;
      label.setAttribute('data-full', full);
      var sig = price.replace(/[0-9]/g, '#');
      var roll = label.querySelector('.kz-roll');
      if (!roll || roll.getAttribute('data-sig') !== sig || label.getAttribute('data-plain')) {
        label.textContent = '';
        var pre = d.createElement('span'); pre.className = 'kz-pre'; pre.textContent = prefix + ' ·'; label.appendChild(pre);
        roll = d.createElement('span'); roll.className = 'kz-roll'; roll.setAttribute('data-sig', sig);
        roll.setAttribute('aria-hidden', 'true');
        price.split('').forEach(function (ch) {
          var c = d.createElement('span');
          if (/[0-9]/.test(ch)) {
            c.className = 'kz-rc';
            var s = d.createElement('span'); s.className = 'kz-rs';
            for (var k = 0; k < 10; k++) { var i = d.createElement('i'); i.textContent = k; s.appendChild(i); }
            c.appendChild(s); c.setAttribute('data-n', '0');
          } else { c.textContent = ch === ' ' ? ' ' : ch; }
          roll.appendChild(c);
        });
        label.appendChild(roll);
        label.removeAttribute('data-plain');
        label.setAttribute('aria-label', full);
        void roll.offsetWidth;
      } else { label.querySelector('.kz-pre').textContent = prefix + ' ·'; }
      var cols = [].slice.call(roll.querySelectorAll('.kz-rc')), digits = price.replace(/[^0-9]/g, '');
      cols.forEach(function (c, idx) {
        var n = Number(digits.charAt(idx)), s = c.firstChild, fromRight = cols.length - 1 - idx;
        if (c.getAttribute('data-n') === String(n) && c.getAttribute('data-set')) return;
        c.setAttribute('data-n', n); c.setAttribute('data-set', '1');
        var tr = 'translateY(' + (-n * 10) + '%)';
        if (!animate || rollReduce) { s.style.transition = 'none'; s.style.transform = tr; return; }
        s.style.transition = 'transform ' + (650 + fromRight * 60) + 'ms cubic-bezier(.34,1.45,.64,1) ' + (fromRight * 55) + 'ms';
        s.style.transform = tr;
      });
      label.setAttribute('aria-label', full);
    }
    function setBtnPlain(label, text) {
      label.textContent = text; label.setAttribute('data-plain', '1'); label.removeAttribute('aria-label');
    }
    var firstApply = true;
    function apply() {
      var r = sel(); if (!r) return;
      idInput.value = r.value;
      radios.forEach(function (x) {
        var t = x.closest('.kz-tier'), was = t.classList.contains('is-selected');
        t.classList.toggle('is-selected', x === r);
        if (x === r && !was && !firstApply && !rollReduce && t.animate)
          t.animate([{ transform: 'scale(.985)' }, { transform: 'scale(1.015)', offset: .55 }, { transform: 'scale(1)' }], { duration: 520, easing: 'cubic-bezier(.34,1.56,.64,1)' });
      });
      var ok = r.getAttribute('data-available') === 'true';
      btn.disabled = !ok;
      var bl = btn.querySelector('[data-kz-btn-label]');
      if (ok) setBtnLabel(bl, btn.getAttribute('data-label'), r.getAttribute('data-price'), !firstApply);
      else setBtnPlain(bl, btn.getAttribute('data-soldout'));
      firstApply = false;
      if (shipEl) shipEl.textContent = r.getAttribute('data-ship') || '';
      qtyEls.forEach(function (q) { q.textContent = r.getAttribute('data-units') || '1'; });
      if (noteEl) noteEl.textContent = r.getAttribute('data-note') || '';
      d.dispatchEvent(new CustomEvent('kz:bundle', { detail: { id: r.value, price: r.getAttribute('data-price'), name: r.getAttribute('data-name'), img: r.getAttribute('data-img'), available: ok } }));
      try { var u = new URL(location.href); u.searchParams.set('variant', r.value); history.replaceState(null, '', u); } catch (e) {}
    }
    radios.forEach(function (r) { r.addEventListener('change', apply); });
    apply();
    var busy = false;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy || btn.disabled) return;
      busy = true; msg.textContent = '';
      var label = btn.querySelector('[data-kz-btn-label]'), old = label.getAttribute('data-full') || label.textContent;
      setBtnPlain(label, btn.getAttribute('data-adding'));
      btn.disabled = true;
      kzToCheckout(Number(idInput.value), 1, btn).catch(function (err) {
          btn.disabled = false; btn.classList.remove('kz-sunk');
          busy = false; setBtnPlain(label, old);
          msg.textContent = btn.getAttribute('data-error') + (err && err.message ? ' (' + err.message + ')' : '');
        });
    });
    var trig = $$('[data-kz-add-trigger]');
    trig.forEach(function (t) { t.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else btn.click(); }); });
  }

  /* sticky mobil-köpbar */
  function initSticky() {
    var bar = $('[data-kz-sticky]'), anchor = $('[data-kz-add]'); if (!bar || !anchor) return;
    var name = $('[data-kz-st-name]', bar), price = $('[data-kz-st-price]', bar), pimg = $('[data-kz-st-img]', bar);
    function upImg(src) { if (pimg && src && pimg.getAttribute('src') !== src) { pimg.hidden = true; pimg.src = src; } }
    d.addEventListener('kz:bundle', function (e) { name.textContent = e.detail.name; price.textContent = e.detail.price; upImg(e.detail.img); });
    var r0 = d.querySelector('input[name="kz-bundle"]:checked'); if (r0) upImg(r0.getAttribute('data-img'));
    if (!('IntersectionObserver' in window)) { bar.classList.add('is-on'); return; }
    var past = false, foot = false;
    function upd() { bar.classList.toggle('is-on', past && !foot); }
    new IntersectionObserver(function (en) { var r = en[0]; past = !r.isIntersecting; upd(); }).observe(anchor);
    var f = $('.kz-foot-sec');
    if (f) new IntersectionObserver(function (en) { foot = en[0].isIntersecting; upd(); }).observe(f);
  }

  /* 15 / 20 */
  function initAngle() {
    $$('[data-kz-angle]').forEach(function (s) {
      $$('input[name="kz-angle"]', s).forEach(function (r) {
        r.addEventListener('change', function () { if (r.checked) s.setAttribute('data-angle', r.value); });
      });
    });
  }

  /* före / efter */
  function initBA() {
    $$('[data-kz-ba]').forEach(function (f) {
      var r = $('input', f);
      function set() { f.style.setProperty('--pos', r.value); r.setAttribute('aria-valuetext', r.value + ' procent'); }
      r.addEventListener('input', set); set();
    });
  }


  /* säljpunkter: "Visa fler" / "Visa färre" */
  function initBullets() {
    var list = $('[data-kz-bullets]'), btn = $('[data-kz-more]'); if (!list || !btn) return;
    var label = $('[data-kz-more-label]', btn);
    function set(open) {
      list.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      label.textContent = btn.getAttribute(open ? 'data-less' : 'data-more');
    }
    btn.addEventListener('click', function () { set(btn.getAttribute('aria-expanded') !== 'true'); });
    d.addEventListener('shopify:block:select', function (e) { if (list.contains(e.target)) set(true); });
  }

  function init() { initBullets(); initHeader(); initReveal(); initGallery(); initBuy(); initSticky(); initAngle(); initBA(); }
  /* tillbaka från kassan med bakåtknappen: köpknapparna ska gå att använda igen */
  window.addEventListener('pageshow', function (e) { if (e.persisted) location.reload(); });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();